var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockOpen01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 7.33333V6.57143C5.5 4.039 7.50714 2 10 2C11.5529 2 12.9172 2.79119 13.7254 4M5.5 7.33333C4.675 7.33333 4 8.01905 4 8.85714V16.4762C4 17.3143 4.675 18 5.5 18H14.5C15.325 18 16 17.3143 16 16.4762V8.85714C16 8.01905 15.325 7.33333 14.5 7.33333H5.5ZM10 11.1429C10.825 11.1429 11.5 11.8286 11.5 12.6667C11.5 13.5048 10.825 14.1905 10 14.1905C9.175 14.1905 8.5 13.5048 8.5 12.6667C8.5 11.8286 9.175 11.1429 10 11.1429Z",
    stroke: "#455468",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockOpen01);
export default __webpack_public_path__ + "static/media/lock-open-01.496a3e609c63d7c5dd35ca68d2f71e2a.svg";
export { ForwardRef as ReactComponent };